export const callStates = {
  CALL_UNAVAILABLE: 'CALL_UNAVAILABLE',
  CALL_AVAILABLE: 'CALL_AVAILABLE',
  CALL_REQUESTED: 'CALL_REQUESTED',
  CALL_IN_PROGRESS: 'CALL_IN_PROGRESS',
}

export const CALL_SET_LOCAL_STREAM = 'CALL_SET_LOCAL_STREAM'
export const CALL_SET_CALL_STATE = 'CALL_SET_CALL_STATE'
export const CALL_SET_CALLING_DIALOGUE_VISIBLE =
  'CALL_SET_CALLING_DIALOGUE_VISIBLE'
export const CALL_SET_CALLER_USERNAME = 'CALL_SET_CALLER_USERNAME'
export const CALL_SET_CALL_REJECTED = 'CALL_SET_CALL_REJECTED'
export const CALL_SET_REMOTE_STREAM = 'CALL_SET_REMOTE_STREAM'
export const CALL_SET_LOCAL_MIC_ENABLED = 'CALL_SET_LOCAL_MIC_ENABLED'
export const CALL_SET_LOCAL_CAM_ENABLED = 'CALL_SET_LOCAL_CAM_ENABLED'
export const CALL_SET_CHAT_MESSAGE = 'CALL_SET_CHAT_MESSAGE_'
export const CALL_SET_ACTIVITY = 'CALL_SET_ACTIVITY'
export const CALL_SET_DRAW_DATA = 'CALL_SET_DRAW_DATA'
